// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2":"46ee1c7f","55":"46ee1c7f","613":"46ee1c7f","767":"46ee1c7f","807":"46ee1c7f"}[chunkId] + ".chunk.css";
};